import { render, staticRenderFns } from "./AdminLoginPage.vue?vue&type=template&id=254fe442&scoped=true"
import script from "./AdminLoginPage.vue?vue&type=script&lang=js"
export * from "./AdminLoginPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254fe442",
  null
  
)

export default component.exports